// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"J-S9DA","checkbox":"c6K9zq0","checkboxLabel":"Vr1Cw8"};